import {
  AutoFixHigh,
  Business,
  Edit,
  Extension,
  FormatListBulleted,
  Groups,
  Layers,
  Logout,
  Notifications,
  Payment,
  Person,
  Settings,
} from "@mui/icons-material";

// import { toAbsoluteUrl } from '_metronic/utils/utils';

export default {
  header: {
    self: {},
    items: [],
  },
  aside: {
    self: {},
    items: [
      {
        title: "Requests",
        root: true,
        // iconUrl: toAbsoluteUrl("/media/icons/requests-icon.svg"),
        icon: Layers,
        page: "requests",
        translate: "MENU.REQUESTS",
        bullet: "dot",
      },
      // {
      //   title: "Reminder Settings",
      //   root: true,
      //   icon: "flaticon2-architecture-and-city",
      //   page: "reminder-settings",
      //   translate: "MENU.REMINDER_SETTINGS",
      //   bullet: "dot"
      // },
      {
        title: "Templates",
        root: true,
        icon: Edit,
        // iconUrl: toAbsoluteUrl("/media/icons/templates-icon.svg"),
        page: "templates",
        translate: "MENU.TEMPLATES",
        bullet: "dot",
      },
      {
        title: "File Renaming",
        root: true,
        icon: AutoFixHigh,
        // iconUrl: toAbsoluteUrl("/media/icons/templates-icon.svg"),
        page: "file-renaming",
        translate: "USER_MENU.FILE_RENAMING",
        submenu: [
          {
            title: "Jobs",
            icon: FormatListBulleted,
            page: "file-renaming/jobs",
            translate: "USER_MENU.FILE_RENAMING_JOBS",
          },
          {
            title: "Rules",
            icon: Settings,
            page: "file-renaming/rules",
            translate: "USER_MENU.FILE_RENAMING_RULES",
          },
        ],
      },
      {
        title: "Profile",
        root: true,
        icon: Person,
        // iconUrl: toAbsoluteUrl("/media/icons/templates-icon.svg"),
        page: "profile",
        translate: "USER_MENU.PROFILE",
        bullet: "dot",
      },
      {
        title: "Notification Settings",
        root: true,
        icon: Notifications,
        // iconUrl: toAbsoluteUrl("/media/icons/templates-icon.svg"),
        page: "notification-settings",
        translate: "USER_MENU.NOTIFICATION_SETTINGS",
        bullet: "dot",
      },
      {
        title: "Integrations",
        root: true,
        icon: Extension,
        // iconUrl: toAbsoluteUrl("/media/icons/templates-icon.svg"),
        page: "integrations",
        translate: "USER_MENU.INTEGRATIONS",
        bullet: "dot",
      },
      {
        title: "Billing",
        root: true,
        icon: Payment,
        // iconUrl: toAbsoluteUrl("/media/icons/templates-icon.svg"),
        page: "billing",
        translate: "USER_MENU.BILLING",
        bullet: "dot",
      },
      {
        title: "Workspace",
        root: true,
        icon: Business,
        page: "workspace",
        translate: "MENU.WORKSPACE",
        submenu: [
          {
            title: "Team",
            icon: Groups,
            page: "workspace/team",
            translate: "MENU.TEAM",
            permission: "team.read",
          },
          {
            title: "Settings",
            icon: Settings,
            page: "workspace/settings",
            translate: "MENU.WORKSPACE_SETTINGS",
            permission: "workspace.update",
          },
        ],
      },
      {
        title: "Logout",
        root: true,
        icon: Logout,
        // iconUrl: toAbsoluteUrl("/media/icons/templates-icon.svg"),
        page: "logout",
        translate: "USER_MENU.LOGOUT",
        bullet: "dot",
      },
    ],
  },
};
